import React, { useState } from "react";
import { Box, Typography } from "@mui/material";

const SeoContentSection = ({
  children,
  collapsedHeight = { xs: "200px", md: "150px" },
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Box
      sx={{
        width: { xs: "100%", md: "84%" },
        margin: "40px auto",
        padding: { xs: "0 12px", md: "0" },
      }}
    >
      <Box
        sx={{
          maxHeight: isExpanded ? "none" : collapsedHeight,
          overflow: "hidden",
          position: "relative",
        }}
      >
        {children}
      </Box>

      <Typography
        onClick={() => setIsExpanded(!isExpanded)}
        sx={{
          marginTop: "10px",
          color: "#024670",
          fontSize: { xs: "12px", md: "14px" },
          fontWeight: "bold",
          cursor: "pointer",
          display: "inline-block",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        {isExpanded ? "Read Less" : "Read More"}
      </Typography>
    </Box>
  );
};

export default SeoContentSection;

